import { formatHeatmapDisplayValue } from '../../../utils/charts/heatmapValueFormat';
import './css/gradientLegend.css';
import React from 'react';

const GradientLegend = ({ colorRange, minValue, midValue, maxValue, valueFormat }) => {
  const colors = Array.isArray(colorRange) ? colorRange : [];
  const gradient = colors.length > 0
    ? `linear-gradient(90deg, ${colors.join(', ')})`
    : 'linear-gradient(90deg, #d9e2ec, #6b8fb3)';

  const formatValue = value => {
    if (valueFormat) return formatHeatmapDisplayValue(value, valueFormat);

    const number = Number(value);
    if (!Number.isFinite(number)) return '--';
    return new Intl.NumberFormat('en-US', {
      maximumFractionDigits: number >= 100 ? 0 : 2,
      minimumFractionDigits: 0,
    }).format(number);
  };

  return (
    <div className="gradientLegend" aria-label="Heatmap value range">
      <div className="gradientLegendScaleMeta">
        <span>Low</span>
        <span>High</span>
      </div>
      <div className="gradientLegendTrackWrap">
        <div
          className="gradientLegendTrack"
          style={{ background: gradient }}
        />
        <div className="gradientLegendTick gradientLegendTickStart" />
        <div className="gradientLegendTick gradientLegendTickMiddle" />
        <div className="gradientLegendTick gradientLegendTickEnd" />
      </div>
      <div className="gradientLegendValueRange">
        <div className="gradientLegendValue">
          <span>Min</span>
          <strong>{formatValue(minValue)}</strong>
        </div>
        <div className="gradientLegendValue gradientLegendValueMiddle">
          <span>Mid</span>
          <strong>{formatValue(midValue)}</strong>
        </div>
        <div className="gradientLegendValue gradientLegendValueEnd">
          <span>Max</span>
          <strong>{formatValue(maxValue)}</strong>
        </div>
      </div>
    </div>
  );
};

export default GradientLegend;
